import messages from './messages';

export const INSURANCES = 'insurances';
export const SERVICES = 'services';
export const SPECIALTIES = 'specialties';
export const TITLE_MESSAGES = {
  INSURANCES: messages.infoListBoxInsurances,
  SERVICES: messages.infoListBoxServices,
  SPECIALTIES: messages.infoListBoxSpecialties
};
export const SEARCH_TITLE_MESSAGES = {
  INSURANCES: messages.infoListBoxInsurancesSearch,
  SERVICES: messages.infoListBoxServicesSearch,
  SPECIALTIES: messages.infoListBoxSpecialtiesSearch
};
export const COLUMN_ROW_BREAK = 5;
export const NUMBER_OF_COLUMNS = 3;
export const TRUNCATE = 15;
export const SHOW_SEARCH_ITEMS_THRESHOLD = 20;

export const LOGGING_EVENTS = {
  CLICK_LOCATIONS_PROVIDER_TILE: 'user_action.provider_tile_locations_page',
  CLICK_LOCATIONS_PROVIDER_TILE_BOOK_APPT:
    'user_action.book_appt_click_locations_page',
  CLICK_LOAD_MORE_PROVIDERS: 'user_action.location.load_more_providers',
  CLICK_SORT_PROVIDERS: 'user_action.location.sort_providers',
  CLICK_FIND_PROVIDERS: 'user_action.location_page.find_providers',
  CLICK_LOCATION_PHONE: 'user_action.location_page.phone_link_click',
  CLICK_LOCATION_WEBSITE_LINK: 'user_action.location_page.website_link_click',
  CLICK_LOCATION_EMAIL_LINK: 'user_action.location_page.email_link_click',
  CLICK_BACK_TO_SEARCH_LINK: 'user_action.location_page.back_to_search'
};

export const LOCATION_NAV_BAR_HEIGHT = '--kyruus-location-nav-bar-height';
